import { Account, AccountJSON, Context, Entity, Finder, TransactionType, TransactionTypeJSON } from "../";

interface TemplateJSON {
    name: string,
    accounts:AccountJSON[],
    transactionTypes: TransactionTypeJSON[],
}

const personalAccounts:TemplateJSON = {
    name: "Common Accounts",
    accounts: [
        {"uuid":"8f5b9331-f247-4784-8cf8-b92d2d0cc5e8","name":"Assets"},
        {"uuid":"71a77199-da73-4d3d-af09-5e1f4f2cd17a","name":"Cash in Wallet", "parent": "8f5b9331-f247-4784-8cf8-b92d2d0cc5e8"},
        {"uuid":"edbc972d-c6d5-4330-b9bd-61c6f3e9422c","name":"Checking Account", "parent": "8f5b9331-f247-4784-8cf8-b92d2d0cc5e8"},
        {"uuid":"533c1880-8856-4415-83f7-8e863a90c5e4","name":"Saving Account", "parent": "8f5b9331-f247-4784-8cf8-b92d2d0cc5e8"},
        {"uuid":"530c1880-8856-4415-83f7-8e863a90c5e4","name":"Debit card", "parent": "8f5b9331-f247-4784-8cf8-b92d2d0cc5e8"},
        {"uuid":"577df501-7927-4ffb-9db9-90030b2f441f","name":"Expenses"},
        {"uuid":"e8eabc44-c05e-4de6-9274-34ac94f83c2d","name":"Groceries", "parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"5ed0fa89-3d5f-4690-9c5f-e1b34cce27f7","name":"Rent", "parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"1f8c0194-2f2a-4d73-bd17-b922bd4a333f","name":"Misc", "parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"b35617e2-e737-4851-81d5-c88fe4f1fbcc","name":"Clothes", "parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"547d426f-c175-4492-b68e-ec69fb7ac9a9","name":"Restaurant", "parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"fae8f9a7-6597-4ff9-94a2-6e40dbce5427","name":"Entertainment","parent": "577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"8ec8b497-d801-4395-b18a-ac28332bc761","name":"Hobbies","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"15961178-376d-4a56-9273-4ae22a592ac1","name":"Insurance","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"a855c072-671c-432c-a194-14297e16a305","name":"Medical","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"bd11c878-6efd-456e-8d59-baff691cd476","name":"Phone","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"82124269-2648-4526-9626-f1dbb00fdaea","name":"Transportation","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"7cd72a28-37bd-4c4a-853e-cecda1749f71","name":"Taxes","parent":"577df501-7927-4ffb-9db9-90030b2f441f"},
        {"uuid":"9866806c-8d04-45b2-92f5-bd46fc3fecf0","name":"Income"},
        {"uuid":"e065d5bc-3c9f-4ad9-9a6a-75254497e382","name":"Salary","parent":"9866806c-8d04-45b2-92f5-bd46fc3fecf0"},
        {"uuid":"2e9fa2ee-c696-4896-9710-f47bc421bfc1","name":"Bonus","parent":"9866806c-8d04-45b2-92f5-bd46fc3fecf0"}
    ],
    transactionTypes: [
        {"uuid":"2c7cc6b1-df9a-4168-af0e-75996098841c","name":"Salary",
            "entries":[
                {"uuid":"09e5e521-9036-49cb-8b78-e0015889921a","account":"e065d5bc-3c9f-4ad9-9a6a-75254497e382","percentage":-100},
                {"uuid":"0bcbef4d-780e-4ae0-a83a-d11e9283b47c","account":"edbc972d-c6d5-4330-b9bd-61c6f3e9422c","percentage":100}]},
        {"uuid":"4cfc3f80-4e9f-4951-8c0c-ea95a3d0bcf7","name":"Insurance",
            "entries":[
                {"uuid":"ffd3c0ce-fc3b-42a1-a96b-8446c3eb039a","account":"15961178-376d-4a56-9273-4ae22a592ac1","percentage":100},
                {"uuid":"b68aa9da-240a-46ad-9ed9-3f79e92a5a92","account":"edbc972d-c6d5-4330-b9bd-61c6f3e9422c","percentage":-100}]},
        {"uuid":"e873bf31-590a-46ce-bd01-3b86fe62fd9c","name":"Rent",
            "entries":[
                {"uuid":"0f6606ec-f999-4a25-9c6f-d8e528cb466a","account":"5ed0fa89-3d5f-4690-9c5f-e1b34cce27f7","percentage":100},
                {"uuid":"850776eb-88e8-46dc-a1c3-7952df4943b8","account":"edbc972d-c6d5-4330-b9bd-61c6f3e9422c","percentage":-100}]},
        {"uuid":"7723749e-5c69-42fa-a521-b9bd473f74d8","name":"Groceries by Bank card",
            "entries":[
                {"uuid":"92ef81f1-3d57-4190-b10e-2bf4b4493eab","account":"e8eabc44-c05e-4de6-9274-34ac94f83c2d","percentage":100},
                {"uuid":"395b505d-e27a-41a8-8216-04a01ab998df","account":"530c1880-8856-4415-83f7-8e863a90c5e4","percentage":-100}]},
        {"uuid":"964a4323-59a7-41c1-9876-47255e8bdda6","name":"Misc cash expenses",
            "entries":[
                {"uuid":"6bbcb5b0-2401-4be8-87e2-f2ce47f22e56","account":"71a77199-da73-4d3d-af09-5e1f4f2cd17a","percentage":-100},
                {"uuid":"daefc2e3-e74f-4fb4-9b0a-3561e1b9bac1","account":"1f8c0194-2f2a-4d73-bd17-b922bd4a333f","percentage":100}]},
        {"uuid":"8552f11b-fe06-4315-97c9-8aa2ec03570f","name":"Transportation with cash",
            "entries":[
                {"uuid":"e302ccbf-f609-453e-884e-45921fa8c7da","account":"71a77199-da73-4d3d-af09-5e1f4f2cd17a","percentage":-100},
                {"uuid":"361d8a6d-333c-4142-8c75-1554ffcc75fb","account":"82124269-2648-4526-9626-f1dbb00fdaea","percentage":100}]},
        ]
}
const simpleAccounts:TemplateJSON = {
    name: "Simple Accounts",
    accounts: [
        {"uuid":"8f5b9331-f247-4784-8cf8-b92d2d0cc5e8","name":"Assets"},
        {"uuid":"570df501-7927-4ffb-9db9-90030b2f441f","name":"Expenses"},
        {"uuid":"507df501-7927-4ffb-9db9-90030b2f441f","name":"Equity"}
    ],
    transactionTypes:[]
}

const emptyAccounts:TemplateJSON = {
    name: "Empty",
    accounts: [],
    transactionTypes:[]
}

class Template {
    private _json: TemplateJSON;
    private _accountRepo: LocalFinder<Account>|undefined = undefined;
    private _init:boolean = false;
    constructor(json:TemplateJSON) {
        this._json = json;
    }

    get name() { return this._json.name; }

    init() {
        if (this._init) {
            return;
        }
        this._accountRepo = new LocalFinder<Account>();
        Context.getInstance().registerFinder(Account, this._accountRepo);
        this._init = true;
    }

    createAccounts() : Account[] {
        this.init();
        if (!this._accountRepo) {
            throw new Error("Illegal state");
        }
        const repo = this._accountRepo;
        this._json.accounts
            .forEach(a => repo.addId(a.uuid, () => Account.fromJson(a)));
        return repo.getAll();
    }

    createTransactionTypes(): TransactionType[] {
        this.init();
        return this._json.transactionTypes
            .map(a => TransactionType.fromJson(a));
    }
}

class LocalFinder<T extends Entity<T>> implements Finder<T> {
    private _indexValueFunc:Record<string, () => T> = {};
    private _indexValue:Record<string, T> = {};

    addId(uuid:string, valueFunc: () => T) {
        this._indexValueFunc[uuid] = valueFunc;
    }

    getAll() : T[] {
        const keys = Object.keys(this._indexValueFunc);
        return keys.map(key => {
            if (!(key in this._indexValue)) {
                this._indexValue[key] = this._indexValueFunc[key]();                
            }
            return this._indexValue[key]
        });
    }

    findById(uuid: string): T {
        if (!(uuid in this._indexValueFunc)) {
            throw new Error("Invalid Id.");            
        }
        this._indexValue[uuid] = this._indexValueFunc[uuid]();
        return this._indexValueFunc[uuid]();
    }
}

const templateList = [new Template(personalAccounts), new Template(simpleAccounts), new Template(emptyAccounts)];

function testTemplate() {
    const generalTemplate = new Template(personalAccounts);
    const accounts = generalTemplate.createAccounts();
    const transactionTypes = generalTemplate.createTransactionTypes();
    console.log(accounts);
    console.log(accounts.map(a => a.fname))
    console.log(transactionTypes);
    console.log(transactionTypes.map(f => f.name))
}

export { Template, templateList }